(function($) {
  'use strict';

  var storageKey = 'coollightsWishlistProductsV1';
  var addSelector = '[data-wishlist-product]';
  var removeSelector = '[data-wishlist-remove]';

  function parseProducts(value) {
    try {
      var products = JSON.parse(value || '[]');
      return Array.isArray(products) ? products : [];
    } catch (error) {
      return [];
    }
  }

  function getProducts() {
    try {
      return parseProducts(window.localStorage.getItem(storageKey));
    } catch (error) {
      return [];
    }
  }

  function saveProducts(products) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(products));
      return true;
    } catch (error) {
      announce('Your browser blocked wishlist storage.');
      return false;
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function productFromButton(button) {
    return {
      id: String(button.getAttribute('data-product-id') || ''),
      title: button.getAttribute('data-product-title') || '',
      url: button.getAttribute('data-product-url') || '#',
      image: button.getAttribute('data-product-image') || '',
      price: button.getAttribute('data-product-price') || '',
      variantId: String(button.getAttribute('data-product-variant-id') || ''),
      variantCount: parseInt(button.getAttribute('data-product-variant-count'), 10) || 0,
      available: button.getAttribute('data-product-available') === 'true'
    };
  }

  function productIndex(products, productId) {
    for (var index = 0; index < products.length; index += 1) {
      if (String(products[index].id) === String(productId)) {
        return index;
      }
    }
    return -1;
  }

  function announce(message) {
    var status = document.querySelector('[data-wishlist-status]');
    if (status) {
      status.textContent = message;
    }
  }

  function toggleProduct(button) {
    var products = getProducts();
    var product = productFromButton(button);
    var index = productIndex(products, product.id);
    var message;

    if (!product.id) {
      announce('This product could not be added to the wishlist.');
      return;
    }

    if (index >= 0) {
      products.splice(index, 1);
      message = product.title + ' removed from your wishlist.';
    } else {
      products.push(product);
      message = product.title + ' added to your wishlist.';
    }

    if (saveProducts(products)) {
      updateButtons();
      renderWishlistPage();
      announce(message);
    }
  }

  function removeProduct(productId) {
    var products = getProducts();
    var index = productIndex(products, productId);

    if (index < 0) {
      return;
    }

    var title = products[index].title;
    products.splice(index, 1);

    if (saveProducts(products)) {
      updateButtons();
      renderWishlistPage();
      announce(title + ' removed from your wishlist.');
    }
  }

  function updateButtons() {
    var products = getProducts();
    var buttons = document.querySelectorAll(addSelector);

    Array.prototype.forEach.call(buttons, function(button) {
      var isAdded = productIndex(products, button.getAttribute('data-product-id')) >= 0;
      var title = isAdded ? 'Added to Wishlist' : 'Add to Wishlist';
      var actionLabel = isAdded ? 'Remove from Wishlist' : 'Add to Wishlist';
      var visibleLabel = isAdded ? 'Added to Wishlist' : 'Add to Wishlist';
      var label = button.querySelector('[data-wishlist-label]');
      var icon = button.querySelector('[data-wishlist-icon]');

      button.setAttribute('aria-pressed', isAdded ? 'true' : 'false');
      button.setAttribute('aria-label', actionLabel);
      button.setAttribute('title', title);
      button.setAttribute('data-original-title', title);
      button.classList.toggle('added', isAdded);
      button.classList.toggle('wish', isAdded);
      if (label) {
        label.textContent = visibleLabel;
      }
      if (icon) {
        icon.textContent = isAdded ? '\u2665' : '\u2661';
      }
    });

    updateHeaderCount(products);
  }

  function updateHeaderCount(products) {
    var count = products.length;
    var counters = document.querySelectorAll('[data-wishlist-count]');
    var headerLinks = document.querySelectorAll('.wishlist-header-link');

    Array.prototype.forEach.call(counters, function(counter) {
      counter.textContent = '';
      counter.hidden = count === 0;
    });

    Array.prototype.forEach.call(headerLinks, function(link) {
      link.classList.toggle('has-items', count > 0);
      link.setAttribute('aria-label', count > 0 ? 'Wishlist, ' + count + ' items' : 'Wishlist');
    });
  }

  function productAction(product) {
    if (!product.available) {
      return '<button type="button" class="shop-button" disabled>Out of stock</button>';
    }

    if (product.variantCount > 1) {
      return '<a class="shop-button" href="' + escapeHtml(product.url) + '">Select option</a>';
    }

    return '<form action="/cart/add" method="post" class="variants" enctype="multipart/form-data">' +
      '<input type="hidden" name="id" value="' + escapeHtml(product.variantId) + '">' +
      '<button type="submit" class="shop-button">Add to cart</button>' +
    '</form>';
  }

  function productRow(product) {
    return '<tr id="wishlist-product-' + escapeHtml(product.id) + '">' +
      '<td class="prod_thumb" data-label="Product Name" data-title="Product">' +
        '<div class="maxus-bxwishlist__img"><a href="' + escapeHtml(product.url) + '">' +
          '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '">' +
        '</a></div>' +
      '</td>' +
      '<td class="prod_title"><p><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></p></td>' +
      '<td class="text-md-center prod_price" data-label="Price" data-title="Price">' +
        '<div class="maxus-bxwishlist__price"><ins>' + escapeHtml(product.price) + '</ins></div>' +
      '</td>' +
      '<td class="text-center prod_btn" data-label="Actions" data-title="Actions">' + productAction(product) + '</td>' +
      '<td class="text-md-center remove" data-label="Remove" data-title="Remove">' +
        '<button type="button" class="remove_prod engoc-remove-item-wishlist" data-wishlist-remove="' + escapeHtml(product.id) + '" aria-label="Remove ' + escapeHtml(product.title) + ' from wishlist">' +
          '<i class="ti-close"></i>' +
        '</button>' +
      '</td>' +
    '</tr>';
  }

  function renderWishlistPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) {
      return;
    }

    var products = getProducts();
    var table = page.querySelector('[data-wishlist-table]');
    var items = page.querySelector('[data-wishlist-items]');
    var empty = page.querySelector('[data-wishlist-empty]');

    if (items) {
      items.innerHTML = products.map(productRow).join('');
    }
    if (table) {
      table.hidden = products.length === 0;
    }
    if (empty) {
      empty.hidden = products.length !== 0;
    }
  }

  function bindEvents() {
    $(document)
      .off('click.coollightsWishlistAdd', addSelector)
      .on('click.coollightsWishlistAdd', addSelector, function(event) {
        event.preventDefault();
        toggleProduct(this);
      });

    $(document)
      .off('click.coollightsWishlistRemove', removeSelector)
      .on('click.coollightsWishlistRemove', removeSelector, function(event) {
        event.preventDefault();
        removeProduct(this.getAttribute('data-wishlist-remove'));
      });
  }

  function initializeWishlist() {
    bindEvents();
    updateButtons();
    renderWishlistPage();
  }

  $(document).ready(initializeWishlist);
  window.addEventListener('storage', function(event) {
    if (event.key === storageKey) {
      updateButtons();
      renderWishlistPage();
    }
  });

  window.initWishlist = initializeWishlist;
  window.initProductWishlist = initializeWishlist;
  window.initRemoveWishlist = initializeWishlist;
})(jQuery);
